import React, { useRef, useEffect, useState } from 'react';

// 마우스 및 터치 입력을 모두 지원하는 서명 캔버스
// onChange(dataUrl | null) — 서명이 있으면 PNG data URL, 비어있으면 null을 전달합니다.
export default function SignaturePad({ onChange, width = 500, height = 200 }) {
  const canvasRef = useRef(null);
  const isDrawing = useRef(false);
  const lastPoint = useRef(null);
  const [isEmpty, setIsEmpty] = useState(true);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    // 레티나 디스플레이 대응 — 캔버스 해상도를 CSS 크기보다 높게 잡아 선명하게 그립니다.
    const ratio = window.devicePixelRatio || 1;
    canvas.width = width * ratio;
    canvas.height = height * ratio;
    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.2;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.strokeStyle = '#102040';
  }, [width, height]);

  function getPoint(e) {
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    if (e.touches && e.touches.length) {
      return { x: e.touches[0].clientX - rect.left, y: e.touches[0].clientY - rect.top };
    }
    return { x: e.clientX - rect.left, y: e.clientY - rect.top };
  }

  function startDrawing(e) {
    e.preventDefault();
    isDrawing.current = true;
    lastPoint.current = getPoint(e);
  }

  function draw(e) {
    if (!isDrawing.current) return;
    e.preventDefault();
    const ctx = canvasRef.current.getContext('2d');
    const point = getPoint(e);
    ctx.beginPath();
    ctx.moveTo(lastPoint.current.x, lastPoint.current.y);
    ctx.lineTo(point.x, point.y);
    ctx.stroke();
    lastPoint.current = point;
    if (isEmpty) setIsEmpty(false);
  }

  function stopDrawing() {
    if (!isDrawing.current) return;
    isDrawing.current = false;
    emitChange();
  }

  function emitChange() {
    if (!onChange) return;
    const canvas = canvasRef.current;
    onChange(isCanvasEmpty(canvas) ? null : canvas.toDataURL('image/png'));
  }

  function isCanvasEmpty(canvas) {
    const ctx = canvas.getContext('2d');
    const pixelData = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
    for (let i = 3; i < pixelData.length; i += 4) {
      if (pixelData[i] !== 0) return false; // alpha 채널이 0이 아니면 그려진 픽셀이 있다는 뜻
    }
    return true;
  }

  function handleClear() {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    setIsEmpty(true);
    if (onChange) onChange(null);
  }

  return (
    <div className="signature-pad">
      <canvas
        ref={canvasRef}
        className="signature-pad__canvas"
        onMouseDown={startDrawing}
        onMouseMove={draw}
        onMouseUp={stopDrawing}
        onMouseLeave={stopDrawing}
        onTouchStart={startDrawing}
        onTouchMove={draw}
        onTouchEnd={stopDrawing}
      />
      <div className="signature-pad__footer">
        <span className="signature-pad__hint">{isEmpty ? '여기에 서명해 주세요' : ''}</span>
        <button type="button" className="signature-pad__clear" onClick={handleClear}>
          다시 쓰기
        </button>
      </div>
    </div>
  );
}
